export default __webpack_public_path__ + "static/media/expage.4b184d09.jpg";